import React, { useState } from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";
import EditableForm from "../components/EditableForm";
import { createCompany } from "../api/userCompanies";
// import { createUserCompany } from "../api/userCompanies"; // <- your POST API call

const CreateUserCompany = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { setIsLoading } = useAppContext();

    const [form, setForm] = useState({
        name: "",
        fiscal_code: "",
        address: "",
        country: "",
        industry: "",
        founded_at: "",
        contact_person_name: "",
        contact_person_email: "",
        contact_person_phone: "",
    });

    const fields = [
        { name: "name", label: t("company.name") },
        { name: "fiscal_code", label: t("company.fiscal_code") },
        { name: "industry", label: t("company.industry") },
        { name: "address", label: t("company.address") },
        { name: "country", label: t("company.country") },
        { name: "founded_at", label: t("company.founded_at"), type: "date" },
        { name: "contact_person_name", label: t("company.contact_person_name") },
        { name: "contact_person_email", label: t("company.contact_person_email") },
        { name: "contact_person_phone", label: t("company.contact_person_phone") },
    ];

    const handleSubmit = async (data) => {
        setIsLoading(true);
        try {
            await createCompany(data); // ✅ API call
            navigate("/"); // ✅ redirect
        } catch (error) {
            console.error("Error creating company:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Box
            sx={{
                flexDirection: "column",
                minHeight: "100vh",
                bgcolor: 'white',
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: 4,
            }}
        >
            <Typography variant="h5" fontWeight="bold" mb={3} textAlign="center">
                {t("company.title")}
            </Typography>

            <EditableForm
                title={t("company.title")}
                data={form}
                fields={fields}
                onChange={setForm}
                onSubmit={handleSubmit}
            />
        </Box>
    );
};

export default CreateUserCompany;
